/** biome-ignore-all lint/a11y/useKeyWithClickEvents: fix accessibility props */
/** biome-ignore-all lint/a11y/useFocusableInteractive: fix accessibility props */
import cx from 'classnames';
import isNil from 'lodash/isNil';
import {useCallback} from 'react';
import {Button} from '~library/atoms/Button';
import {CheckmarkIcon} from '~library/svg/CheckmarkIcon';
import {emeraldWebText} from '~libSass/base/_exports.sass';

import './FontItem.sass';

export const weights = {
  200: ' Extra Light',
  300: ' Light',
  400: ' Regular',
  500: ' Medium',
  600: ' Semi Bold',
  700: ' Bold',
  800: ' Extra Bold',
  900: ' Black',
};

const styles = {
  normal: '',
  italic: ' Italic',
};

export const FontItem = ({
  font,
  selected = false,
  onClick,
  scroll = true,
  isSimple = false,
  isRecentlyUsedFonts = false,
}) => {
  if (isNil(font)) {
    return null;
  }

  const onClickHandler = useCallback(() => onClick(font), [font, onClick]);

  let fontDisplayName;
  if (isRecentlyUsedFonts) {
    fontDisplayName = font.name;
  } else if (isSimple) {
    fontDisplayName = font.family;
  } else {
    fontDisplayName = `${weights[font.weight]} ${styles[font.style]}`;
  }

  return (
    <Button
      className={cx('font-item', {'font-item--selected': selected})}
      onClick={onClickHandler}
      role="button"
      color="fog"
      data-type={font.type} // this isn't allowed here!
    >
      <p
        key={`${font.family}-${font.weight}-${font.style}`}
        style={{
          fontFamily: font?.family,
          fontWeight: font?.weight ?? 'normal',
          fontStyle: font?.style ?? 'normal',
        }}
      >
        {fontDisplayName}
      </p>
      {!!selected && <CheckmarkIcon ratio={0.75} color={emeraldWebText} />}
    </Button>
  );
};
